/** @graphql agg **/

import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	DataSecurityPolicyAction,
	useIsActionDisabledForWorkspaceQuery$data,
	useIsActionDisabledForWorkspaceQuery$variables,
} from './__generated__/useIsActionDisabledForWorkspaceQuery.graphql.ts';

export const useIsActionDisabledForWorkspaceQuery = graphql`
	query useIsActionDisabledForWorkspaceQuery($action: DataSecurityPolicyAction!) {
		dataSecurityPolicy {
			isActionEnabledForWorkspace(action: $action) {
				action
				allowed
			}
		}
	}
`;

export interface UseIsActionDisabledForWorkspaceArgs {
	action: DataSecurityPolicyAction;
	skip?: boolean;
}

export const useIsActionDisabledForWorkspace = ({
	action,
	skip = false,
}: UseIsActionDisabledForWorkspaceArgs): boolean => {
	const { data } = useQueryInterop<
		useIsActionDisabledForWorkspaceQuery$data,
		useIsActionDisabledForWorkspaceQuery$variables
	>(useIsActionDisabledForWorkspaceQuery, {
		variables: { action },
		fetchPolicy: 'cache-and-network',
		skip,
	});
	if (skip) {
		return false;
	}
	const allowedResp = data?.dataSecurityPolicy?.isActionEnabledForWorkspace?.allowed;
	// Defaults to disabled if we don't have a definitive answer
	return allowedResp === undefined || allowedResp === null ? true : !allowedResp;
};
